<template>
  <div>
    <div :class="{'row': $mq==='mobile', 'row': $mq==='desktop', 'catFlow': $mq==='tablet'} ">
      <div :class="{'col-12': $mq==='mobile', 'col-4': $mq!=='tablet' && $mq!=='mobile', 'catContainer': $mq==='tablet' }" 
            v-for="(category, idx) in categories" 
            v-bind:key="idx"
            :style="{'padding': getPadding()}"
            @click="$router.push({path: '/categories/'+ category.id})">
        <div class="categoryBox" :style="{backgroundColor: getOpacity()}">
          <div class="text">{{category.name}}</div>
          <div class="img"><img v-if="category.photo" :alt="category.name" :src="$store.getters.getImgPath + '/categories/photo/' + category.photo"/></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryConn from '@/connection/categories.js'


export default {

  name: 'CategoriesBox',

  data () {
    return {
      categories: []
    }
  },

  mounted () {
    // non reactive data
    this.idxColor = 0
    this.directionColor = -1

    CategoryConn.getAll()
      .then ((r) => {
        this.categories = r.data
        console.log(this.categories)
      })
      .catch ((e) => {
        console.log('error ', e)
      })
  },

  methods: {
    

    getPadding () {
      if (this.$mq==='mobile') {
        return '0'
      } else {
        return '0 15px'
      }
    },

    getOpacity () {
      let calc = 0
      if (this.directionColor === -1){
        calc = 1 - ((this.idxColor * 5)/100)
        if (calc < 0.75) {
          this.idxColor = 0
          this.directionColor = 1
          calc = 0.8
        }
      } else {
        calc = 0.8 + ((this.idxColor * 5)/100)
        if (calc > 1){
          this.idxColor = 0
          this.directionColor = -1
          calc = 0.95
        }
      }
      this.idxColor = this.idxColor + 1
      return 'rgba(44, 42, 41,' + calc + ')'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/_variables.scss";
.categoryBox {
  height: 113px;
  border-top:1px solid #ffffff;
  display:flex;
  @media screen and (min-width: $mobile) and (max-width: $tablet){
    max-height: 113px!important;
    min-width:200px;
    border: 0px;
    border-radius: 4px;
    margin:0px;
    padding:0px;
    
  }
  @media screen and (min-width: $tablet){
    border: 0px;
    height: 113px;
    border-radius: 4px;
    margin:5px;
    cursor:pointer;
  }
  .text {
    width: calc(100vw - 133px);
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    padding:10px;
    margin: auto 10px;
    line-height:113px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (min-width: $mobile) and (max-width: $tablet) {
      width:200px;
      max-width: 280px;
      margin:0px;
      padding: 0 10px;
      height: 113px;
    }
  }
  .img {
    width: 113px;
    height: 113px;
    opacity:0.9;
     @media screen and (min-width: $mobile) and (max-width: $tablet) {
      margin: 0px!important;
      padding: 0px!important;
      max-height:113px!important;
     }
    img {
      @media screen and (min-width: $mobile) and (max-width: $tablet) {
        border-radius: 0 4px 4px 0;
        width: 113px;
        height: 113px;
      }

      @media screen and (min-width: $tablet) {
        border-radius: 0 4px 4px 0;
        width: 113px;
        height: 113px;
      }

      @media screen and (max-width: $mobile) {
        width: 113px;
        height: 113px;
      }
    }
  }
}

.catFlow {
  height: 135px;
  width: 100vw;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  display: inline-flex;
}

.catContainer {
  height: 113px;
  // border-radius: 4px;
  // border:1px solid #ffffff;
  margin: 0px 5px;
  // display: inline-flex;
  //display: table;
}
</style>
